/**
 * This is used for the introduction wizard
 */

// import { now } from "d3-timer";

export class Feedback {
   version: string;
   userId: string;
   optOut: Boolean;
   rating?: number;
   message?: string;
   date : string;
   
   constructor(userId: string, version: string, optOut: Boolean, rating?: number, message?: string) {
      this.userId = userId
      this.version = version;
      this.optOut = optOut;
      if(!! rating) 
         this.rating = rating;
      
      if(!! message)
         this.message = message;
         
      this.date = new Date().toString();
   }
}